<template>
  <span></span>
</template>

<script>

import { fetchUser } from '@/api'

export default {
  name: 'home',

  mounted () {

    fetchUser().then(data => {
      const primaryAccountId = data.accounts[0].id
      this.$router.push({ name: 'projects', params: { accountId: primaryAccountId } })
    })

  }

}
</script>
